var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FixedPopup", { class: { onFocus: _vm.onFocus } }, [
    _vm.nowStep == "0"
      ? _c("div", { staticClass: "stepBox step0Box" }, [
          _c("div", { staticClass: "stepBox__pic" }, [
            _c("img", {
              attrs: { src: require("@/assets/插圖/s1.png"), alt: "" }
            })
          ]),
          _c("div", { staticClass: "stepBox__content" }, [
            _c("h2", [_vm._v("想进行帐号归户吗？")]),
            _c("div", { staticClass: "stepBox__content__desc" }, [
              _vm._v(
                "\n        曾经登入发现「已解锁内容」需再次付费，可能是过去「使用不同帐号登入」所导致。您可以透过「帐号归户」来整合管理所有帐户星盘与订单，或是「维持原样」各别管理不同帐号。\n      "
              )
            ]),
            _c("label", { staticClass: "checkbox-pri" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.setNoNeedToRemind,
                    expression: "setNoNeedToRemind"
                  }
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.setNoNeedToRemind)
                    ? _vm._i(_vm.setNoNeedToRemind, null) > -1
                    : _vm.setNoNeedToRemind
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.setNoNeedToRemind,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.setNoNeedToRemind = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.setNoNeedToRemind = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.setNoNeedToRemind = $$c
                    }
                  }
                }
              }),
              _c("span", { staticClass: "checkmark" }),
              _vm._v("\n        不再提醒\n      ")
            ])
          ]),
          _c("div", { staticClass: "stepBox__footer" }, [
            _c(
              "div",
              {
                staticClass: "step0Box__skip",
                on: {
                  click: function($event) {
                    return _vm.nextTime()
                  }
                }
              },
              [_vm._v("下次再说")]
            ),
            _c(
              "div",
              {
                staticClass: "step0Box__start",
                on: {
                  click: function($event) {
                    _vm.nowStep = 1
                  }
                }
              },
              [_vm._v("帐号归户")]
            )
          ]),
          _c("div", { staticClass: "step0Box__swapAccount" }, [
            _vm._v("\n      想使用其他帐号登入吗?\n      "),
            _c(
              "span",
              {
                on: {
                  click: function($event) {
                    return _vm.swapAccount()
                  }
                }
              },
              [_vm._v("改用其他帐号")]
            )
          ])
        ])
      : _vm._e(),
    _vm.nowStep == "1"
      ? _c("div", { staticClass: "stepBox step1Box" }, [
          _c("div", { staticClass: "stepBox__pic" }, [
            _c("img", {
              attrs: { src: require("@/assets/插圖/s1.png"), alt: "" }
            })
          ]),
          _c(
            "div",
            {
              staticClass: "stepBox__close",
              on: {
                click: function($event) {
                  return _vm.nextTime()
                }
              }
            },
            [
              _c("img", {
                attrs: { src: require("@/assets/icon_menu-close-dark.svg") }
              })
            ]
          ),
          _c("div", { staticClass: "stepBox__content" }, [
            _c("h2", [_vm._v("帐号归户设定")]),
            _c("div", { staticClass: "stepBox__content__desc" }, [
              _vm._v(
                "\n        若曾透过 Line、Facebook 或 Google\n        注册过帐号，「帐号归户」可以将您各帐号的好友与星盘合并在一起。\n      "
              )
            ]),
            _c("div", { staticClass: "step1Box__form" }, [
              _c("div", { staticClass: "step1Box__form__input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.recipientMail,
                      expression: "recipientMail",
                      modifiers: { trim: true }
                    }
                  ],
                  attrs: {
                    type: "email",
                    id: "email",
                    placeholder: "輸入 Email 來歸戶帳號"
                  },
                  domProps: { value: _vm.recipientMail },
                  on: {
                    hover: function($event) {
                      _vm.onFocus = true
                    },
                    blur: [
                      function($event) {
                        _vm.onFocus = false
                        _vm.emailFormatError = false
                      },
                      function($event) {
                        return _vm.$forceUpdate()
                      }
                    ],
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.recipientMail = $event.target.value.trim()
                    }
                  }
                })
              ]),
              _c(
                "div",
                {
                  staticClass: "step1Box__form__submit",
                  class: { disable: _vm.waiting || !_vm.recipientMail },
                  on: {
                    click: function($event) {
                      return _vm.step1__sendEmail()
                    }
                  }
                },
                [_vm._v("\n          验证\n        ")]
              )
            ]),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.emailFormatError,
                    expression: "emailFormatError"
                  }
                ],
                staticClass: "inputError"
              },
              [_vm._v("Email格式有误!")]
            ),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.emailSendFrequent,
                    expression: "emailSendFrequent"
                  }
                ],
                staticClass: "inputError"
              },
              [
                _vm._v(
                  "\n        您的信件验证已达本日上限，请确认您输入的信箱是否正确或是检查验证信是否误判为垃圾邮件，谢谢！\n      "
                )
              ]
            )
          ])
        ])
      : _vm._e(),
    _vm.nowStep == "2"
      ? _c("div", { staticClass: "stepBox step2Box" }, [
          _c("div", { staticClass: "stepBox__pic" }, [
            _c("img", {
              attrs: { src: require("@/assets/插圖/develop.svg"), alt: "" }
            })
          ]),
          _c("div", { staticClass: "stepBox__content" }, [
            _c("h2", [_vm._v("信箱验证")]),
            _c("div", { staticClass: "stepBox__content__desc" }, [
              _vm._v("\n        验证码已寄至您的信箱，请输入验证码\n      ")
            ]),
            _c("div", { staticClass: "step2Box__form" }, [
              _c(
                "div",
                {
                  staticClass: "verification-code-input",
                  class: { captchaError: _vm.captchaError }
                },
                [
                  _c(
                    "div",
                    { staticClass: "verification-code-input-group" },
                    _vm._l(_vm.inputs, function(input, index) {
                      return _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: input.value,
                            expression: "input.value"
                          }
                        ],
                        key: index,
                        ref: "input" + index,
                        refInFor: true,
                        class: { active: input.active },
                        attrs: {
                          type: "tel",
                          maxlength: "1",
                          autocomplete: "off",
                          placeholder: "●"
                        },
                        domProps: { value: input.value },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(input, "value", $event.target.value)
                            },
                            function($event) {
                              return _vm.handleInput(index)
                            }
                          ],
                          keydown: function($event) {
                            return _vm.handleKeyDown(index, $event)
                          },
                          focus: function($event) {
                            _vm.onFocus = true
                          },
                          blur: function($event) {
                            _vm.onFocus = false
                          }
                        }
                      })
                    }),
                    0
                  ),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.captchaError,
                          expression: "captchaError"
                        }
                      ],
                      staticClass: "inputError"
                    },
                    [_vm._v("请输入正确的验证码")]
                  )
                ]
              )
            ]),
            _c("p", { staticClass: "step2Box__resend" }, [
              _c("span", { staticClass: "step2Box__resend__time" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.block_countdown + "s") +
                    "\n        "
                )
              ]),
              _vm._v("\n        后将可以重新发验证码\n        "),
              _c(
                "span",
                {
                  staticClass: "step2Box__resend__btn",
                  class: { active: _vm.block_CanSend },
                  on: {
                    click: function($event) {
                      return _vm.step1__sendEmail()
                    }
                  }
                },
                [_vm._v("发送验证码")]
              )
            ])
          ]),
          _c(
            "div",
            {
              staticClass: "step2Box__submit",
              class: { notReady: _vm.inputCaptcha.length !== 6 },
              on: {
                click: function($event) {
                  return _vm.importToAccount()
                }
              }
            },
            [_vm._v("\n      送出\n    ")]
          ),
          _c(
            "div",
            {
              staticClass: "step2Box__back",
              on: {
                click: function($event) {
                  return _vm.backStep1()
                }
              }
            },
            [_vm._v("回上一页")]
          )
        ])
      : _vm._e(),
    _vm.nowStep == "3"
      ? _c("div", { staticClass: "step3Box" }, [
          _c("img", {
            staticClass: "step3Box__img",
            attrs: { src: require("@/assets/ok.svg"), alt: "" }
          }),
          _c("div", { staticClass: "step3Box__title" }, [
            _vm._v("信箱已验证成功，谢谢您！")
          ]),
          _c(
            "div",
            {
              staticClass: "step3Box__close",
              on: {
                click: function($event) {
                  _vm.nowStep = "4"
                }
              }
            },
            [
              _c("img", {
                attrs: { src: require("@/assets/close.svg"), alt: "" }
              })
            ]
          )
        ])
      : _vm._e(),
    _vm.nowStep == "4"
      ? _c("div", { staticClass: "stepBox step4Box" }, [
          _c("div", { staticClass: "stepBox__pic" }, [
            _c("img", {
              attrs: { src: require("@/assets/插圖/s1.png"), alt: "" }
            })
          ]),
          _c("div", { staticClass: "stepBox__content" }, [
            _c("h2", [_vm._v("帐号归户成功")]),
            _c("div", { staticClass: "stepBox__content__desc" }, [
              _vm._v(
                "\n        已成功将您的\n        " +
                  _vm._s(_vm.sccessPlatforms.join("、")) +
                  "\n        整合在同一个帐号下。未来您可以自由地透过 Facebook、Line、Google\n        或信箱来登入帐号。\n        "
              ),
              _c("br"),
              _c("br"),
              _vm._v(
                "点击「前往好友列表」，您可以看到合并后的好友名单喔~\n      "
              )
            ])
          ]),
          _c("div", { staticClass: "step4Box__btnGroup" }, [
            _c(
              "div",
              {
                staticClass: "step4Box__btnGroup__toFriend",
                on: {
                  click: function($event) {
                    return _vm.toFriend()
                  }
                }
              },
              [_vm._v("\n        前往好友列表\n      ")]
            ),
            _c(
              "div",
              {
                staticClass: "step4Box__btnGroup__toImportList",
                on: {
                  click: function($event) {
                    return _vm.toImportList()
                  }
                }
              },
              [_vm._v("\n        查看帐号归户\n      ")]
            )
          ])
        ])
      : _vm._e(),
    _vm.nowStep == "5"
      ? _c("div", { staticClass: "stepBox step5Box" }, [
          _c("div", { staticClass: "stepBox__pic" }, [
            _c("img", {
              staticClass: "hidden-mobile-down",
              attrs: { src: require("@/assets/歸戶提示.png"), alt: "" }
            }),
            _c("img", {
              staticClass: "hidden-mobile-up",
              attrs: { src: require("@/assets/歸戶提示_m.png"), alt: "" }
            })
          ]),
          _c("div", { staticClass: "stepBox__content" }, [
            _c("h2", [
              _vm._v("\n        未来仍可从个人帐号中\n        "),
              _c("br"),
              _vm._v("设定「帐号归户」喔\n      ")
            ]),
            _c("div", { staticClass: "stepBox__content__desc" }, [
              _vm._v(
                "\n        未来若想设定「帐号归户」，您仍可以透过点击个人帐号的选单，来设定「帐号归户」。\n      "
              )
            ])
          ]),
          _c(
            "div",
            {
              staticClass: "step5Box__btn",
              on: {
                click: function($event) {
                  return _vm.close()
                }
              }
            },
            [_vm._v("了解")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }